/* Structured Space — Match Quiz engine (vanilla JS, no deps) */
(function () {
  'use strict';

  var ICON = {
    cloud: 'M7 18a4 4 0 0 1 0-8 5.5 5.5 0 0 1 10.6-1.6A4.2 4.2 0 0 1 17.5 18z',
    device: 'M7 4h10a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1zm2 13h6',
    print: 'M7 9V4h10v5m-10 8H5a1 1 0 0 1-1-1v-5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1h-2m-10 0h10v4H7z',
    phone: 'M9 3h6a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zm2 15h2',
    bolt: 'M13 3 4 14h6l-1 7 9-11h-6z',
    refresh: 'M19 12a7 7 0 1 1-2-4.9M19 4v4h-4',
    heart: 'M12 20s-7-4.4-9.2-8.2A4.6 4.6 0 0 1 12 6a4.6 4.6 0 0 1 9.2 5.8C19 15.6 12 20 12 20z',
    clock: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zm0-14v5l3 2',
    grid: 'M4 4h7v7H4zm9 0h7v7h-7zM4 13h7v7H4zm9 0h7v7h-7z',
    sparkle: 'M12 4l1.6 4.6L18 10l-4.4 1.4L12 16l-1.6-4.6L6 10l4.4-1.4zM18 15l.8 2.2L21 18l-2.2.8L18 21l-.8-2.2L15 18l2.2-.8z',
    leaf: 'M5 19c0-8 6-13 14-13 0 8-5 14-14 14zm0 0c2-5 5-7 9-8.5',
    download: 'M12 4v10m0 0 4-4m-4 4-4-4M5 19h14',
    chevron: 'M9 6l6 6-6 6',
    check: 'M5 12.5 10 17l9-10',
    lock: 'M7 11V8a5 5 0 0 1 10 0v3m-11 0h12v10H6z'
  };

  function icon(name, size, color, sw) {
    var d = ICON[name] || ICON.sparkle;
    return '<svg width="' + (size || 22) + '" height="' + (size || 22) + '" viewBox="0 0 24 24" fill="none" stroke="' + (color || 'currentColor') + '" stroke-width="' + (sw || 1.7) + '" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" style="flex:none"><path d="' + d + '"/></svg>';
  }

  /* Quiz now matches shoppers to a PRODUCT (not a format).
     Outcomes: life_admin, adhd, weekly_reset, bundle */
  var QUESTIONS = [
    { key: 'struggle', eyebrow: 'Question 1', title: "What's weighing on you most right now?", sub: "There's no wrong answer — just go with your gut.", options: [
      { ic: 'clock', label: 'Bills, appointments, the everyday pile-up', note: 'Life admin in general', w: { life_admin: 2 } },
      { ic: 'sparkle', label: 'Overwhelm, focus, a busy brain', note: 'ADHD or executive dysfunction', w: { adhd: 2 } },
      { ic: 'leaf', label: 'Just want a simple weekly reset', note: 'Something light to start', w: { weekly_reset: 2 } },
      { ic: 'grid', label: 'Honestly, a bit of everything', note: 'Life admin and ADHD-style overwhelm', w: { life_admin: 1, adhd: 1, bundle: 1 } }
    ] },
    { key: 'depth', eyebrow: 'Question 2', title: 'How much structure feels right?', sub: 'Some of us want everything mapped out. Some of us want the bare minimum.', options: [
      { ic: 'bolt', label: 'Just the essentials, nothing extra', note: 'Light and simple', w: { weekly_reset: 2 } },
      { ic: 'device', label: 'A proper dashboard for daily life', note: 'Tasks, bills, routines in one place', w: { life_admin: 2 } },
      { ic: 'cloud', label: 'Something built around focus and energy', note: 'ADHD-specific tools', w: { adhd: 2 } },
      { ic: 'refresh', label: 'I want it all, in one place', note: 'Both planners together', w: { bundle: 2 } }
    ] },
    { key: 'commitment', eyebrow: 'Question 3', title: 'What feels right to start with?', sub: 'Last one — promise.', options: [
      { ic: 'download', label: 'Something free, to try first', note: 'No risk, see how it feels', w: { weekly_reset: 2 } },
      { ic: 'grid', label: 'One planner that fits my main struggle', note: 'Worth investing a little', w: { life_admin: 1, adhd: 1 } },
      { ic: 'sparkle', label: 'Go all in — both planners', note: 'Best value if I need both', w: { bundle: 2 } }
    ] }
  ];

  var FMT = {
    life_admin: { name: 'The Life Admin Planner', label: 'Life Admin', icon: 'cloud', accent: ['#F3ECF6', '#B59CC9', '#8A6B9E'], why: 'You want one calm dashboard for bills, tasks, appointments and the everyday pile-up — hosted in your browser with instant access after purchase.' },
    adhd: { name: 'The ADHD Life Planner', label: 'ADHD Life Planner', icon: 'sparkle', accent: ['#FBEEE2', '#E0A877', '#B8784A'], why: 'You want something built specifically around focus, overwhelm and ADHD-friendly structure — hosted in your browser with cloud sync after activation.' },
    weekly_reset: { name: 'The free Weekly Reset Planner', label: 'Weekly Reset', icon: 'leaf', accent: ['#EAF1E8', '#7FA67A', '#5D8159'], why: "You want something light to try first, no cost and no pressure. It's a calm, reusable single page — a gentle place to start." },
    bundle: { name: 'The Structured Space Bundle', label: 'Bundle', icon: 'grid', accent: ['#F4F2EE', '#C9BEAE', '#8A6B9E'], why: 'You want both planners working together — life admin and ADHD-friendly structure in one calm system, at the best combined value.' }
  };

  function plannerArt(accent) {
    var bg = accent[0], mid = accent[1], deep = accent[2], rows = '';
    for (var i = 0; i < 5; i++) {
      var w = 90 - i * 7, c = (i % 3 === 0) ? mid : 'var(--ss-line)';
      rows += '<div style="display:flex;align-items:center;gap:9px"><span style="width:13px;height:13px;border-radius:4px;border:2px solid ' + mid + ';flex:none;background:rgba(255,255,255,.6)"></span><span style="height:8px;border-radius:4px;width:' + w + '%;background:' + c + '"></span></div>';
    }
    return '<div style="background:' + bg + ';border-radius:12px;overflow:hidden;width:100%;aspect-ratio:4/3.2;display:flex;flex-direction:column;border:1px solid rgba(52,70,59,.06)"><div style="height:26px;background:' + deep + ';display:flex;align-items:center;padding:0 12px;gap:5px"><span style="width:7px;height:7px;border-radius:50%;background:rgba(255,255,255,.55)"></span><span style="width:7px;height:7px;border-radius:50%;background:rgba(255,255,255,.55)"></span><span style="width:7px;height:7px;border-radius:50%;background:rgba(255,255,255,.55)"></span></div><div style="flex:1;padding:16px;display:flex;flex-direction:column;gap:10px"><div style="width:52%;height:11px;border-radius:4px;background:' + deep + ';opacity:.85"></div>' + rows + '</div></div>';
  }

  function laptop(src, alt) {
    return '<div class="ss-laptop"><div class="ss-laptop__lid"><span class="ss-laptop__cam"></span><div class="ss-laptop__screen"><img src="' + src + '" alt="' + (alt || '') + '" loading="lazy"></div></div><div class="ss-laptop__base"><span class="ss-laptop__notch"></span></div></div>';
  }

  function compute(answers) {
    var score = { life_admin: 0, adhd: 0, weekly_reset: 0, bundle: 0 };
    QUESTIONS.forEach(function (q) {
      var ai = answers[q.key];
      if (ai == null || !q.options[ai] || !q.options[ai].w) return;
      var w = q.options[ai].w;
      Object.keys(w).forEach(function (k) { score[k] += w[k]; });
    });
    return Object.keys(score).sort(function (a, b) { return score[b] - score[a]; })[0] || 'life_admin';
  }

  function showOnly(screens, name) {
    Object.keys(screens).forEach(function (key) {
      if (screens[key]) screens[key].hidden = key !== name;
    });
  }

  function initQuiz(root) {
    if (!root || root.__ssInit) return;
    root.__ssInit = true;

    var cfg = {
      links: { life_admin: root.dataset.linkLifeAdmin, adhd: root.dataset.linkAdhd, weekly_reset: root.dataset.linkWeeklyReset, bundle: root.dataset.linkBundle, all: root.dataset.linkAll },
      imgs: { life_admin: root.dataset.imgLifeAdmin, adhd: root.dataset.imgAdhd, weekly_reset: root.dataset.imgWeeklyReset, bundle: root.dataset.imgBundle }
    };

    var screens = {
      intro: root.querySelector('[data-ss-screen="intro"]'),
      question: root.querySelector('[data-ss-screen="question"]'),
      result: root.querySelector('[data-ss-screen="result"]')
    };

    var stepEl = root.querySelector('[data-ss-step]');
    var fillEl = root.querySelector('[data-ss-fill]');
    var countEl = root.querySelector('[data-ss-count]');
    var backEl = root.querySelector('[data-ss-back]');
    var startEl = root.querySelector('[data-ss-start]');
    var retakeEl = root.querySelector('[data-ss-retake]');
    var browseEl = root.querySelector('[data-ss-browse]');

    if (!startEl || !stepEl || !fillEl || !countEl || !backEl) return;

    var state = { step: -1, answers: {} };
    var total = QUESTIONS.length;

    function focusTop() {
      var top = root.getBoundingClientRect().top + window.pageYOffset - 80;
      if (top < window.pageYOffset) window.scrollTo({ top: top, behavior: 'smooth' });
    }

    function renderQuestion() {
      var q = QUESTIONS[state.step];
      if (!q) return;
      var pct = Math.round((state.step / total) * 100);
      fillEl.style.width = pct + '%';
      countEl.textContent = (state.step + 1) + ' of ' + total;
      backEl.disabled = state.step === 0;

      var html = '<span class="ss-eyebrow ss-quiz__eyebrow">' + q.eyebrow + '</span>';
      html += '<h2 class="ss-quiz__title">' + q.title + '</h2>';
      html += '<p class="ss-quiz__sub">' + q.sub + '</p>';
      html += '<div class="ss-quiz__options">';

      q.options.forEach(function (o, oi) {
        var sel = state.answers[q.key] === oi;
        html += '<button type="button" class="ss-opt' + (sel ? ' is-sel' : '') + '" data-opt="' + oi + '">';
        html += '<span class="ss-opt__ic">' + icon(o.ic, 24, 'var(--ss-sage-deep)') + '</span>';
        html += '<span class="ss-opt__txt"><strong>' + o.label + '</strong><span>' + o.note + '</span></span>';
        html += '<span class="ss-opt__check">' + icon('check', 15, '#fff', 2.5) + '</span>';
        html += '</button>';
      });

      html += '</div>';
      stepEl.innerHTML = html;

      Array.prototype.forEach.call(stepEl.querySelectorAll('[data-opt]'), function (btn) {
        btn.addEventListener('click', function () {
          state.answers[q.key] = parseInt(btn.getAttribute('data-opt'), 10);
          Array.prototype.forEach.call(stepEl.querySelectorAll('.ss-opt'), function (b) { b.classList.remove('is-sel'); });
          btn.classList.add('is-sel');
          setTimeout(next, 180);
        });
      });
    }

    function renderResult() {
      var fmt = compute(state.answers);
      var info = FMT[fmt];
      showOnly(screens, 'result');
      if (fillEl) fillEl.style.width = '100%';
      var titleEl = root.querySelector('[data-ss-result-title]');
      var whyEl = root.querySelector('[data-ss-result-why]');
      var cardEl = root.querySelector('[data-ss-result-card]');
      if (titleEl) titleEl.textContent = info.name + ' suits you best.';
      if (whyEl) whyEl.textContent = info.why;
      var img = cfg.imgs[fmt];
      var art = img ? laptop(img, info.label + ' planner') : plannerArt(info.accent);
      var link = cfg.links[fmt] || cfg.links.all || '/collections/all';
      if (cardEl) {
        cardEl.innerHTML = '<div class="ss-match__top"><div class="ss-match__art">' + art + '</div><div><span class="ss-match__fmt">' + icon(info.icon, 14, 'var(--ss-sage-deep)') + ' ' + info.label + '</span><h2>' + info.name.replace(/^The /, '') + '</h2><p class="ss-match__why">' + info.why + '</p><div class="ss-match__cta"><a class="ss-btn ss-btn--primary" href="' + link + '">View this planner ' + icon('chevron', 16, '#fff') + '</a></div></div></div>';
      }
      if (browseEl) browseEl.setAttribute('href', cfg.links.all || '/collections/all');
      focusTop();
    }

    function next() {
      state.step += 1;
      if (state.step >= total) {
        renderResult();
        return;
      }
      showOnly(screens, 'question');
      renderQuestion();
      focusTop();
    }

    startEl.addEventListener('click', function (event) {
      event.preventDefault();
      state.step = 0;
      showOnly(screens, 'question');
      renderQuestion();
      focusTop();
    });

    backEl.addEventListener('click', function (event) {
      event.preventDefault();
      if (state.step > 0) {
        state.step -= 1;
        renderQuestion();
        focusTop();
      }
    });

    if (retakeEl) {
      retakeEl.addEventListener('click', function (event) {
        event.preventDefault();
        state.answers = {};
        state.step = -1;
        showOnly(screens, 'intro');
        focusTop();
      });
    }
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-ss-quiz]'), initQuiz);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', boot);
})();
